export function getProductVariantPrices(product, variation, attributes, selectedAttributes) {
    const extra = selectedAttributes.reduce((total, selected) => {
        const attribute = attributes.find(item => String(item.ProductAttributeID) === String(selected.ProductAttributeID)
            && String(item.PrimaryKeyValue) === String(selected.PrimaryKeyValue));
        return total + (Number(attribute?.AdditionalPrice) || 0);
    }, 0);
    const round = value => Math.round((value + Number.EPSILON) * 100) / 100;
    return {
        price: round((variation ? variation.price : Number(product.Price) || 0) + extra),
        discountedPrice: !variation && Number(product.DiscountedPrice) > 0
            ? round(Number(product.DiscountedPrice) + extra) : 0
    };
}
